import { Info } from "@phosphor-icons/react";

import Skeleton from "common/components/ui/Skeleton";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "common/components/ui/Tooltip";

import type { ReactNode } from "react";

export default function PricingItem({
  labelContent,
  valueContent,
  isLoading,
  tooltipText,
}: {
  labelContent: ReactNode;
  valueContent: ReactNode;
  isLoading: boolean;
  tooltipText?: string;
}) {
  return (
    <div className="flex justify-between px-2">
      <div className="flex text-button-sm text-black-600 items-center gap-x-0.5">
        {labelContent}
        {tooltipText && (
          <Tooltip>
            <TooltipTrigger>
              <Info className="text-black-300 size-4" weight="fill" />
            </TooltipTrigger>
            <TooltipContent>{tooltipText}</TooltipContent>
          </Tooltip>
        )}
      </div>
      {isLoading ? (
        <Skeleton className="h-5 w-28" />
      ) : (
        <span className="text-black-500 text-md-medium">{valueContent}</span>
      )}
    </div>
  );
}
